import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'payment.page.card.details.month': {
    id: 'payment.page.card.details.month',
    defaultMessage: 'Month',
    description: 'The month a credit card expires',
  },
  'payment.page.card.details.year': {
    id: 'payment.page.card.details.year',
    defaultMessage: 'Year',
    description: 'The year a credit card expires',
  },
});

export default messages;
